module.exports = __webpack_public_path__ + "img/iconNo10.0c86fbe2.png";